var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColorsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d5863;opacity:0.75;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "colors_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,1.39a10.61,10.61,0,0,0,0,21.22,1.77,1.77,0,0,0,1.77-1.77,1.8,1.8,0,0,0-.46-1.19,1.76,1.76,0,0,1,1.32-2.93h2.09a5.9,5.9,0,0,0,5.89-5.9C22.61,5.61,17.86,1.39,12,1.39ZM5.52,12a1.77,1.77,0,1,1,1.76-1.77A1.77,1.77,0,0,1,5.52,12ZM9.05,7.28a1.77,1.77,0,1,1,1.77-1.76A1.76,1.76,0,0,1,9.05,7.28Zm5.9,0a1.77,1.77,0,1,1,1.77-1.76A1.76,1.76,0,0,1,15,7.28ZM18.48,12a1.77,1.77,0,1,1,1.77-1.77A1.76,1.76,0,0,1,18.48,12Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorsIcon);
export default __webpack_public_path__ + "static/media/colors_icon.62c80113699704b921f168a0f4060b12.svg";
export { ForwardRef as ReactComponent };